module.exports = "/images/success-tick.gif?1d435e0c166bdb6d34b79cd91cadbb38";